// side: 'left' (gray) | 'right' (wa-light green)
export default function ChatBubble({ side = 'left', children, time }) {
  const isRight = side === 'right';
  return (
    <div className={`flex ${isRight ? 'justify-end' : 'justify-start'} mb-2`}>
      <div
        className={`max-w-xs lg:max-w-md px-4 py-2 rounded-lg shadow-sm text-sm relative overflow-hidden
          ${isRight ? 'bg-wa-light text-wa-text rounded-br-none' : 'bg-white text-wa-text rounded-bl-none'}`}
      >
        {children}
        {time && (
          <span className="block text-right text-xs text-gray-400 mt-1">{time}</span>
        )}
      </div>
    </div>
  );
}
